import React, { useState } from 'react';
import { ArrowLeft, Plus, Minus, Utensils, Wine } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useCart } from './CartContex';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, clearCart, handleDecreaseItem, handleAddItem } = useCart();

  const foodItems = cartItems.filter(item => item.drinks === false);
  const drinkItems = cartItems.filter(item => item.drinks === true);

  const totalAmount = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const [showTablePopup, setShowTablePopup] = useState(false);
  const [tableNumber, setTableNumber] = useState('');
  const [instructions, setInstructions] = useState('');
  // Add this function to place the order
  const placeOrder = async () => {
    try {
      const token = localStorage.getItem('tringAuthToken');

      const userResponse = await fetchWithAuth(API_ENDPOINTS.USERS, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const userData = await userResponse.json();

      // Prepare order payload
      const orderPayload = {
        venueId: localStorage.getItem('venueId'),
        tableNumber: tableNumber,
        customerName: `${userData.first_name} ${userData.last_name}`,
        customerPhone: userData.phone_number,
        items: cartItems.map(item => ({
          menuItemId: item.id,
          quantity: item.quantity,
          specialInstructions: '',
          // selectedVariations: item.configuration?.variations ? [{
          //   name: item.configuration.variations.name,
          //   price: item.configuration.variations.price
          // }] : [],
          selectedCustomizations: item.configuration?.customizations
            ? {
                name: Object.values(item.configuration.customizations)[0].name,
                price: Object.values(item.configuration.customizations)[0]
                  .price,
              }
            : {},
        })),
        notes: instructions,
      };
      console.log(orderPayload);
      console.log('item variation', cartItems);

      // Post order
      const orderResponse = await fetchWithAuth(API_ENDPOINTS.MENU_ORDER, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderPayload),
      });

      if (orderResponse.ok) {
        clearCart();
        navigate('/menu');
      } else {
        console.error('Failed to place order');
      }
    } catch (error) {
      console.error('Error placing order:', error);
    }
  };

  const CartItem = ({ item }) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 16px',
        backgroundColor: '#f9f9f9',
        borderRadius: '12px',
      }}
    >
      <div style={{ flex: 1 }}>
        <h3
          style={{
            margin: '0',
            fontSize: '14px',
            textAlign: 'left',
          }}
        >
          {item.name}
        </h3>

        {item.configuration && (
          <div
            style={{
              marginTop: '8px',
              fontSize: '13px',
              color: '#666',
              textAlign: 'left',
            }}
          >
            {item.configuration.variations && (
              <div>• {item.configuration.variations.name}</div>
            )}
            {item.configuration.addons?.length > 0 && (
              <div>
                {item.configuration.addons.map(addon => (
                  <div key={addon.id}>• {addon.name}</div>
                ))}
              </div>
            )}
            {item.configuration.customizations &&
              Object.values(item.configuration.customizations).length > 0 && (
                <div>
                  {Object.values(item.configuration.customizations).map(
                    (option, idx) => (
                      <div key={idx}>• {option.name}</div>
                    )
                  )}
                </div>
              )}
          </div>
        )}
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            backgroundColor: '#22C55E',
            borderRadius: '20px',
            padding: '2px 6px',
            color: 'white',
          }}
        >
          <Minus
            size={16}
            onClick={() => handleDecreaseItem(item.cartId)}
            style={{ cursor: 'pointer' }}
          />
          <span>{item.quantity}</span>
          <Plus
            size={16}
            onClick={() => handleAddItem(item, item.configuration)}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div
      style={{
        backgroundColor: '#f5f5f5',
        minHeight: '100vh',
        maxWidth: '500px',
        margin: '0 auto',
        position: 'relative',
        paddingBottom: '120px',
      }}
    >
      {/* Header */}
      <div
        style={{
          padding: '16px',
          borderBottom: '1px solid #eee',
          position: 'sticky',
          top: 0,
          backgroundColor: 'white',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <ArrowLeft
          size={24}
          onClick={() => navigate(-1)}
          style={{ cursor: 'pointer' }}
        />
        <h1
          style={{
            margin: 0,
            fontSize: '20px',
            fontWeight: '700',
            color: '#333',
          }}
        >
          Order Summary
        </h1>
      </div>

      {/* Cart Content */}
      <div style={{ padding: '16px' }}>
        {cartItems.length === 0 ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '40px 20px',
              gap: '16px',
              backgroundColor: 'white',
              borderRadius: '12px',
              marginTop: '16px',
            }}
          >
            <p
              style={{
                textAlign: 'center',
                color: '#666',
                fontSize: '16px',
                margin: 0,
              }}
            >
              Please add items from menu
            </p>
            <button
              onClick={() => navigate(-1)}
              style={{
                marginTop: '16px',
                padding: '12px 24px',
                backgroundColor: '#CC151E',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              Browse Menu
            </button>
          </div>
        ) : (
          <>
            {/* Food Items Section */}
            {foodItems.length > 0 && (
              <div
                style={{
                  marginBottom: '14px',
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  padding: '16px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '16px',
                  }}
                >
                  <Utensils size={20} color="#333" />
                  <h3
                    style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      margin: 0,
                      color: '#333',
                    }}
                  >
                    Food Items
                  </h3>
                  <span
                    style={{
                      marginLeft: 'auto',
                      fontSize: '14px',
                      color: '#666',
                    }}
                  >
                    {foodItems.length} items
                  </span>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                  }}
                >
                  {foodItems.map(item => (
                    <CartItem key={item.cartId} item={item} />
                  ))}
                </div>
              </div>
            )}

            {/* Drink Items Section */}
            {drinkItems.length > 0 && (
              <div
                style={{
                  marginBottom: '24px',
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  padding: '16px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '16px',
                  }}
                >
                  <Wine size={20} color="#333" />
                  <h3
                    style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      margin: 0,
                      color: '#333',
                    }}
                  >
                    Drinks
                  </h3>
                  <span
                    style={{
                      marginLeft: 'auto',
                      fontSize: '14px',
                      color: '#666',
                    }}
                  >
                    {drinkItems.length} items
                  </span>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                  }}
                >
                  {drinkItems.map(item => (
                    <CartItem key={item.cartId} item={item} />
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {showTablePopup && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 2000,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '12px',
              width: '80%',
              maxWidth: '400px',
            }}
          >
            <h3 style={{ marginTop: 0 }}>Order Details</h3>

            <div style={{ marginBottom: '16px' }}>
              <label
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: '500',
                }}
              >
                Table Number
              </label>
              <input
                type="text"
                value={tableNumber}
                onChange={e => setTableNumber(e.target.value)}
                placeholder="e.g., A1"
                style={{
                  width: '100%',
                  padding: '10px',
                  fontSize: '16px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                }}
              />
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: '500',
                }}
              >
                Special Instructions (Optional)
              </label>
              <textarea
                value={instructions}
                onChange={e => setInstructions(e.target.value)}
                placeholder="Any special requests?"
                style={{
                  width: '100%',
                  padding: '10px',
                  fontSize: '16px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  minHeight: '80px',
                }}
              />
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
              }}
            >
              <button
                onClick={() => setShowTablePopup(false)}
                style={{
                  padding: '8px 16px',
                  background: '#eee',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (!tableNumber) {
                    alert('Please enter a table number');
                    return;
                  }
                  setShowTablePopup(false);
                  placeOrder();
                }}
                style={{
                  padding: '8px 16px',
                  background: '#22C55E',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
              >
                Place Order
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Cart Summary */}
      {/* <div
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          maxWidth: '500px',
          margin: '0 auto',
          backgroundColor: 'white',
          padding: '8px',
          borderTop: '1px solid #eee',

          zIndex: 1000,
        }}
      > */}
      {/* <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px"
              }}>
                <div style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  color: "#333"
                }}>
                  Total Amount
                </div>
                <div style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  color: "#CC151E"
                }}>
                  ₹{totalAmount.toFixed(2)}
                </div>
              </div> */}

      {/* <button
        onClick={() => setShowTablePopup(true)}
        style={{
          width: '100%',
          padding: '12px 16px',
          backgroundColor: '#22C55E',
          color: 'white',
          border: 'none',
          borderRadius: '12px',
          fontSize: '15px',
          fontWeight: '600',
          cursor: 'pointer',
        }}
      >
        Place Order
      </button> */}
      {/* </div> */}
    </div>
  );
};

export default CartPage;
